import { Link } from "@mui/material";
import React, { useMemo } from "react";
import { AppTheme } from "theme";

interface IProps {
  text: string;
}

const URL_REGEXP = /((?:https?:\/\/|www\.)[^\s<>]+)/gi;
// Знаки пунктуации в конце ссылки обычно относятся к тексту, а не к ссылке
const TRAILING_PUNCTUATION = /[.,;:!?)\]}»"'…]+$/;

export default function LinkifiedText(props: IProps) {
  const { text } = props;

  const parts = useMemo(() => {
    return text.split(URL_REGEXP).map((part, index) => {
      // Нечетные элементы split с capture-группой - это найденные ссылки
      if (index % 2 === 0) {
        return part;
      }
      const trailing = part.match(TRAILING_PUNCTUATION)?.[0] ?? "";
      const url = trailing ? part.slice(0, -trailing.length) : part;
      const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
      return (
        <React.Fragment key={index}>
          <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            sx={{
              color: AppTheme.darkButtonBg,
              textDecorationColor: "currentColor",
              wordBreak: "break-all",
              '@media (prefers-color-scheme: dark)': {
                color: AppTheme.darkButtonBgDark,
              },
            }}
          >{url}</Link>
          {trailing}
        </React.Fragment>
      );
    });
  }, [text]);

  return <>{parts}</>;
}
